module.exports = __webpack_public_path__ + "portal-static/img/图标1.ed33cbed.png";